import React , {Component} from "react";

import {Container, Row ,Col} from "react-bootstrap";

export default class ErrorPage extends Component
{
    render()
    {
        return(
            <div style={{height:"100%"}}>
                <Container >
                    <Row >
                        <Col xs="12">
                            404
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}



